module.exports = __webpack_public_path__ + "static/media/right-underline-2.28b5342f.svg";